import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { baseURL, handleAxiosError } from "./servicesUtils";
var baseController = "".concat(baseURL, "/rest/request");
export var sendSuggestion = suggestion => __awaiter(void 0, void 0, void 0, function* () {
  var res = yield axios.post("".concat(baseController, "/sendSuggestion"), suggestion);
  return res.data;
});
export var addGenericRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/addRequestGeneric"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendPublishRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendPublishRequest"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendFacileRequestFromMr = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res;
    if (data.service === "1") res = yield axios.post("".concat(baseController, "/sendFacileMarketReportMutuoRequest"), data);else res = yield axios.post("".concat(baseController, "/sendFacileMarketReportServiceRequest"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendAiraRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendAiraRequest"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendMrExampleRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseURL, "/rest/mail/sendBrochureMR"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendNotAvailableValuationRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendNotAvailableValuationRequest"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendPrestigiousRequest = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseController, "/sendPrestigiousRequest"), data);
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var sendWidgetRequest = suggestion => __awaiter(void 0, void 0, void 0, function* () {
  var res = yield axios.post("".concat(baseController, "/sendWidgetRequest"), suggestion);
  return res.data;
});